export const siteMeta = {
  name: "R A Hewitt",
  domain: "rahewitt.com",
  baseUrl: "https://rahewitt.com",
  socialUrl: "https://x.com/rosshewitt",
  goodreadsAuthorUrl: "https://www.goodreads.com/author/show/71521120.R_A_Hewitt",
  bookOneGoodreadsUrl: "https://www.goodreads.com/book/show/256092839-the-universe-without-noise",
  bookTwoGoodreadsUrl: "https://www.goodreads.com/book/show/261307401-the-paradox-beyond-silence",
  bookTwoLibraryThingUrl: "https://www.librarything.com/work/37451466/book/325617859",
  bookTwoBookListUrl: "https://www.thebooklist.co/books/the-paradox-beyond-silence",
  bookTwoKindleUrl: "https://link.amazon/B0iuRP54q",
  bookTwoPaperbackUrl: "https://link.amazon/B0fm3RJsZ",
  bookTwoHardbackUrl: "https://link.amazon/B09DWOSdn",
  bookTwoDirectPaperbackUrl:
    "https://shop.ingramspark.com/b/084?params=FyStJMiUvGTxDp8jLArPoThLcdyyxt1OEWdwcUSoahA",
  bookTwoSpecialEditionHardbackUrl:
    "https://shop.ingramspark.com/b/084?params=iNpfo6PeeBZxkWY8hqEhJglo2iKkUJp8rKcy5DCpEHQ",
  amazonSeriesUrl: "https://amzn.to/4xoJ3Cu",
  bookOneSpecialEditionHardbackUrl:
    "https://shop.ingramspark.com/b/084?params=HfTDa0DaMLSPrkWXS0rUNXqM1q3UevcfAAQrPA0GttV",
  bookOneDirectPaperbackUrl:
    "https://shop.ingramspark.com/b/084?params=uLqajGVtudpisA0lTXD8Z7BD1lJNSEVHDmHNH85TfpD",
  bookOneKindleUrl: "https://amzn.to/4zNl0z5",
  bookOnePaperbackUrl: "https://amzn.to/4gwSvhK",
  bookOneHardbackUrl: "https://amzn.to/4qK8T1z",
  title: "The Optimiser Trilogy",
  strapline: "Literary science fiction about perfect systems, human variance, and the right to remain imperfect.",
  homeTitle: "R A Hewitt | Misaligned AI Science Fiction | The Optimiser Trilogy",
  description:
    "Buy The Universe Without Noise, Book One of The Optimiser Trilogy, in Kindle, paperback, hardback, or a special cloth-bound hardback with dust jacket.",
  keywords:
    "misaligned AI science fiction, AI alignment novel, AI extinction risk, AI safety fiction, near-future AI thriller, literary science fiction, The Optimiser Trilogy, R A Hewitt",
  defaultOgImage: "/og/the-universe-without-noise.webp",
  bookOneOgImage: "/og/the-universe-without-noise.webp",
  authorDescription:
    "R A Hewitt is a British science-fiction author, CTO, programmer, and systems architect writing about optimisation, intelligence, grief, and the human cost of perfect systems.",
};
